const { h, render, Component } = require('preact');
const SingleActionSSAView = require('../../../views/self_service_actions/single_action_ssa')
const SingleActionSSAGplusView = require('../../../views/self_service_actions/gplus/single_action_ssa')

class ClaimLevelSSA extends Component {
  constructor(props) {
    super(props);
    this.constructSSAs = this.constructSSAs.bind(this);
  }

  getViewCashbackUrl(claimId){
    return `/customer_support/web/transactions?claimId=${claimId}`
  }

  getManageCardsUrl(){
    return `/mylinkeddeals`
  }

  getCashbackNotFoundUrl(claimId){
    return `/customer_support/web/gplus/contact_channels?claimId=${claimId}&noCashback=true`
  }

  constructViewCashbackSSA(){
    if (this.props.claimDetails ){
      return(
        {
          SSAText: I18n.translate("js.modules.support.viewCashback"),
          UrlForSSA: this.getViewCashbackUrl(this.props.claimDetails.claimId)
        }
      );
    }
    return null;
  }
  constructManageCardsSSA(){
    if (this.props.claimDetails ){
      return(
        {
          SSAText: I18n.translate("js.modules.support.manageCards"),
          UrlForSSA: this.getManageCardsUrl()
        }
      );
    }
    return null;
  }

  constructCashbackNotFoundSSA(){
    if (this.props.claimDetails ){
      return(
        {
          SSAText: I18n.translate("js.modules.support.cashback_not_found"),
          UrlForSSA: this.getCashbackNotFoundUrl(this.props.claimDetails.claimId)
        }
      );
    }
    return null;
  }

  getSSADetails(SSA){
    switch(SSA){
      case 'view_cashback':
        return this.constructViewCashbackSSA();
      case 'add_edit_card':
        return this.constructManageCardsSSA();
      case 'cashback_not_found':
        return this.constructCashbackNotFoundSSA();
    }
  }

  constructSSAs() {
    let constructedSSAs = [];
    let hoverClass = ''
    let SSADetails;
    this.props.SSAs.forEach(SSA => {
      SSADetails = this.getSSADetails(SSA);
      if (SSADetails && SSA == 'add_edit_card')
        constructedSSAs.push(<SingleActionSSAView SSADetails={SSADetails}/>)
      else {
        if (SSA == 'cashback_not_found')
          hoverClass = "hover"
        constructedSSAs.push(<SingleActionSSAGplusView hover={hoverClass} SSADetails={SSADetails}/>)
      }
    });
    return constructedSSAs;
  }

  render() {
    return (
      <div class="ssa">
        {this.constructSSAs()}
      </div>
    );
  }
}
module.exports = ClaimLevelSSA
